import { DOCUMENTS_SAGA_GET_DOCUMENTS_FOR_ME } from '../actionTypes'

 
export const getDocumentsForMe = (year: number, user: any) => ({
    type: DOCUMENTS_SAGA_GET_DOCUMENTS_FOR_ME,
    year,
    user,
})
